import { Avatar, Button, Checkbox, Col, DatePicker, Drawer, Flex, Form, Input, InputNumber, Layout, Radio, Row, Select, Switch, Table, Tag, Tooltip, Upload, message, theme } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import RecurringEnd from './RecurringEnd';
import FormItem from 'antd/es/form/FormItem';
import { InboxOutlined, DeleteOutlined, CheckOutlined, EyeOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons';
import VotingEnd from './VotingEnd';
import AddAgendaItem from './AddAgendaItem';
import AgendaItemVoting from './AgendaItemVoting';
import VoteResult from './VoteResult';
import { useDispatch, useSelector } from 'react-redux';
import { agendaCapture, screenEnded, screenStart } from '../../../../redux/slices/meetingSlice';

const { RangePicker } = DatePicker;
const { Header, Sider, Content } = Layout;
const { TextArea } = Input;

const onOk = (value) => {
    console.log('onOk: ', value);
};

const options = [
    {
        label: 'Zoom',
        value: 'zoom',
    },
    {
        label: 'Google Meet',
        value: 'Google Meet',
    },
];

const { Dragger } = Upload;
const props = {
    name: 'file',
    multiple: true,
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    onChange(info) {
        const { status } = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};

const dataSource = [
    {
        key: '1',
        agendaItem: 'Agenda 1',
        attachementName: 'Attachement 1',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
    {
        key: '2',
        agendaItem: 'Agenda 1',
        attachementName: 'Attachement 1',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
    {
        key: '3',
        agendaItem: 'Agenda 1',
        attachementName: 'Attachement 1',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
];

const columns = [
    {
        title: 'ID',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: 'Agenda Item',
        dataIndex: 'agendaItem',
        key: 'agendaItem',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (_, record) => (
            <Flex gap="small" justify="center" align="center" vertical>
                <Flex gap="middle" wrap="wrap">
                    <Button icon={<EyeOutlined />} size='small' />
                    <Button type="primary" icon={<DownloadOutlined />} size='small' />
                    <Button type="primary" icon={<EditOutlined />} size='small' />
                    <Button danger type="primary" icon={<DeleteOutlined />} size='small' />
                </Flex>
            </Flex>
        ),
    }
];

export default function AgendaItem() {
    const agendaScreenRef = useRef();
    const dispatch = useDispatch();
    const agenda = useSelector(state => state.meeting.agendas);
    const {
        token: { colorPrimary, colorBgContainer, borderRadiusLG, colorTextPlaceholder },
    } = theme.useToken();
    const [avatarColor, setAvatarColor] = useState(colorTextPlaceholder);

    const handleClick = () => {
        setAvatarColor(prevColor => prevColor === colorTextPlaceholder ? colorPrimary : colorTextPlaceholder);
    };
    const [openAddNewAgendaDrawer, setOpenAddNewAgendaDrawer] = useState(false);
    const [attachement, setAttachement] = useState([]);
    const [agendaDisplayTableData, setAgendaDisplayTableData] = useState([]);
    const [allowVoting, setAllowVoting] = useState(false);
    const [votingData, setVotingData] = useState({
        isEnabled: false,
        end: {
            type: 'after',
            customDate: null,
            customTime: null
        }
    });

    const showDrawer = () => {
        setOpenAddNewAgendaDrawer(true);
    };
    const onClose = () => {
        setVotingData({
            isEnabled: false,
            end: {
                type: 'after',
                customDate: null,
                customTime: null
            }
        });
        
        // Reset the form fields
        agendaScreenRef.current.resetFormFields();
        setOpenAddNewAgendaDrawer(false);
    };

    const handleAgendaItemSave = async () => {
        try {
            const values = await agendaScreenRef.current.validateAndRetrieveData();
            dispatch(screenStart());
            const { agendaItem, description, attachmentName } = values;

            const formattedValues = {
                name: agendaItem,
                description: description ? description : null,
                attachments: attachement,
                voting: votingData
            }

            dispatch(agendaCapture(formattedValues));
            // Reset the form fields
            agendaScreenRef.current.resetFormFields();

            onClose();
        } catch (error) {
            console.log("error in agenda :", error);
        }
    }

    useEffect(() => {
        if (agenda.length > 0) {
            const dataSource = agenda.map((item, index) => {
                return {
                    key: index + 1,
                    agendaItem: item.name
                };
            });
            setAgendaDisplayTableData(dataSource);
        }
    }, [agenda]);

    return (
        <>
            <Form layout="vertical">
                <Row gutter={24}>
                    <Col span={24}>
                        <Table
                            dataSource={agendaDisplayTableData}
                            columns={columns}
                            title={() => (
                                <Flex justify='space-between' align='center'>
                                    <span>Added Items</span>
                                    <Button type="primary" onClick={showDrawer}>
                                        Add New Item
                                    </Button>
                                </Flex>
                            )}
                            expandable={{
                                expandedRowRender: (record) => (
                                    record.description !== "" ?
                                        <p
                                            style={{
                                                margin: 0,
                                            }}
                                        >
                                            {record.description}
                                        </p> : ""
                                ),
                                rowExpandable: (record) => record.rsvp !== 'yes',
                            }}
                        />
                        {/* this need to be use view story id 26 4th screen */}
                        {/* <AgendaItemVoting /> */}

                        {/* this need to be use view story id 26 5th screen */}
                        {/* <VoteResult /> */}

                        <Drawer
                            size='large'
                            title="Add new agenda item"
                            onClose={onClose}
                            open={openAddNewAgendaDrawer}
                            footer={[
                                <Flex justify='flex-end' align='center' gap='large'>
                                    <Button>
                                        Cancel
                                    </Button>
                                    <Button type="primary" onClick={handleAgendaItemSave}>
                                        Save
                                    </Button>
                                </Flex>
                            ]
                            }
                        >
                            <AddAgendaItem
                                ref={agendaScreenRef}
                                attachement={attachement}
                                setAttachement={setAttachement}
                                allowVoting={allowVoting}
                                setAllowVoting={setAllowVoting}
                                setVotingData={setVotingData}
                            />
                        </Drawer>
                    </Col>
                </Row>
            </Form>
        </>
    )
}
